import { IDataSetColumn } from '@adaptiva/core/common';
import { LoggingService } from '@adaptiva/core/logging';
import { BaseActionOverlay, BeforeSubmitFn, OverlayService } from '@adaptiva/core/overlays';
import { ISortEvent, SchemaAndRows, TableSortService } from '@adaptiva/core/tables';
import { IUiWidgetConfig, UiService } from '@adaptiva/core/ui';
import { TextConfig } from '@adaptiva/core/widgets';
import { ICopiedMetadataProperty, MetadataObject, MetadataPropertyCopyService } from '@adaptiva/metadata/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BehaviorSubject, take } from 'rxjs';

@Component({
	standalone: false,
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'ada-copy-properties-overlay',
	templateUrl: './copy-properties-overlay.component.html',
	providers: [TableSortService]
})
export class CopyPropertiesOverlayComponent<T extends MetadataObject> extends BaseActionOverlay<T> implements OnInit {

	public override title: string = 'Copy Properties';

	public copyOptions$: BehaviorSubject<SchemaAndRows> = new BehaviorSubject(new SchemaAndRows([], [], 0));

	private readonly _metadataPropertyCopyingSchema: IDataSetColumn[] = [
		new TextConfig({ columnName: 'propertyMap', columnDisplay: 'Namespace', type: 'string', isHeading: true, sortable: true }),
		new TextConfig({ columnName: 'propertyName', columnDisplay: 'Property', type: 'string', isHeading: true, sortable: true }),
		new TextConfig({ columnName: 'propertyDisplayValue', columnDisplay: 'Value', type: 'string', isHeading: true, sortable: false }),
		{ columnName: 'propertyValue', type: 'noop', isHeading: false },
	];

	private _optionsToCopy: ICopiedMetadataProperty[] = [];

	constructor(
		protected copyService: MetadataPropertyCopyService,
		private _sortService: TableSortService,
		_logger: LoggingService,
		_overlayService: OverlayService,
		_uiService: UiService,
	) {
		super(_overlayService, _uiService, _logger);
	}

	public ngOnInit(): void {
		if (this.context)
			this.applyContext(this.context);

		this.copyService.generatePropertyOptions(this.context).pipe(take(1)).subscribe({
			next: (_properties: ICopiedMetadataProperty[]) => {
				const _tableData: SchemaAndRows = new SchemaAndRows(
					this._metadataPropertyCopyingSchema,
					_properties,
					_properties.length
				);
				this.copyOptions$.next(_tableData);
			}
		});
	}

	public override beforeSubmit: BeforeSubmitFn = (): boolean => {
		this.copyProperties();
		return true;
	};

	public sortCopyOptions(_event: ISortEvent, _data$: BehaviorSubject<SchemaAndRows<ICopiedMetadataProperty>>): void {
		_data$.pipe(
			take(1),
		).subscribe((_tableData: SchemaAndRows<ICopiedMetadataProperty>) => {
			_tableData.rows = this._sortService.sort<ICopiedMetadataProperty>(_tableData.rows, _event.sortConfig);
			_data$.next(_tableData);
		});
	}

	protected override applyContext(_context: T): void {

	}

	protected changeCopySelection(_selectedProperties: ICopiedMetadataProperty[]): void {
		this._optionsToCopy = _selectedProperties;
	}

	protected copyProperties(): void {
		this.copyService.copyProperties(this.context, this._optionsToCopy);
	}

}
